export interface MetricGoal {
    coachingMetricId: number;
    authorCommentDate: string;
    authorComment: string;
    coreValueId: number | null;
    goalComment: string;
    nextMonthGoal: number | null;
    CoachingSkillId: number | null;
    CoachingBehaviorId: number | null;
}

export const transformDataUpdateMetricForm = (coachingMetricGoal: any) => {
    const metricGoal = coachingMetricGoal?.data?.map((item: any) => {
        const metric: MetricGoal = {
            coachingMetricId: item.coaching_metric_id,
            authorCommentDate: item.author_comment_date,
            authorComment: item.author_comment ?? '',
            coreValueId: item.core_value_id ?? null,
            goalComment: item.goal_comment ?? '',
            nextMonthGoal: item.next_month_goal ?? null,
            CoachingSkillId: item.coaching_skill_id ?? null,
            CoachingBehaviorId: item.coaching_behavior_id ?? null
        };
        return metric;
    });

    return metricGoal;
};
